/**
 *  subHeaderDirective.js
 *  @description Sets up "sub-header" (the .pageActions element in Bonsai) to follow Bonsai global standards and allow for help, as well as any other action buttons.
 *  @param {function} helpAction displays help button in .pageActions and sets this as the on click function
 *  @param {boolean} hideRoot hides the default root element to allow you to have full control of breadcrumbs in the controller
 *  @param {boolean} showCurrentPage shows the current page / last item in the breadcrumbs array (for cases where no page title exists)
 *  @param {boolean} hideBackBtn hides the back button on the root bread crumb
 *  @param {boolean} noFollow adds no-follow attribute to links so google bot doesn't crawl these links
 */
/*global define, dna*/
define('core/directives/subHeaderDirective',[
    'angular',
    'text!core/directives/subHeader.html',
    'core/services/SubHeaderService',
    'core/services/TestsService'
], function (angular, subHeaderHtml) {
    'use strict';
    angular.module('dnaApp').directive('subHeader', ['$rootScope', '$location', 'SubHeaderService', 'TestsService','$route','$routeParams',
        function ($rootScope, $location, SubHeaderService, TestsService, $route, $routeParams) {
            return {
                restrict: 'E',
                scope: {
                    helpAction: '&',
                    showHelpText: '='
                },
                template: subHeaderHtml,
                transclude: true,
                link: function ($scope, element, attrs, ctrl, transclude) {

                    /**
                     * @method _init
                     * @desc Setup the $scope
                     * @private
                     */
                    function init() {
                        // Setup $scope data
                        if (!dna.app.isUserAuthenticated) {
                            // The user is NOT logged in so we are going to force him back to the HomeController where
                            // which will then show the logged out home page.
                            $scope.appRoot = '/';
                            $scope.appRootTarget = '_self';
                        } else {
                            // lastSelectedTest was getting lost on page reload. This resets it when the subHeader is rebuilt
                            if ($routeParams && $routeParams.testGuid && !TestsService.lastSelectedTest) {
                                TestsService.lastSelectedTest = $routeParams.testGuid;
                            }
                            $scope.appRoot = TestsService.getHomePath();
                        }
                        $scope.testGuid = "";
                        if($routeParams && $routeParams.testGuid){
                            $scope.testGuid = $routeParams.testGuid;
                        }
                        $scope.hideRoot = 'hideRoot' in attrs;
                        $scope.showBackForFirstBreadcrumb = $scope.hideRoot && ('showBackForFirstBreadcrumb' in attrs);
                        $scope.showCurrentPage = 'showCurrentPage' in attrs;
                        $scope.hideBackBtn = 'hideBackBtn' in attrs;
                        $scope.breadCrumbs = SubHeaderService.getBreadCrumbs();
                        $scope.showHelp = 'helpAction' in attrs;
                        if ('noFollow' in attrs) {
                            $scope.noFollow = 'nofollow';
                        }
                        $scope.hasPageActions = $scope.showHelp;

                        $scope.clickCrumb = function (breadCrumb) {
                            if (breadCrumb.callback) {
                                breadCrumb.callback();
                            }
                        };

                        // Add classes to directive element
                        element.addClass('pageActions clearfix');

                        // Transclude content and append to element (i.e., content inside directive gets appended to subHeader directive)
                        transclude(function (clone) {
                            element.append(clone);
                            $scope.hasPageActions = $scope.showHelp || element.children().length > 1;
                        });

                        // Watch the value of the breadCrumbs array in the SubHeaderService so we can keep the breadCrumbs in the sub-header up-to-date.
                        $scope.$watch(function () {
                            return SubHeaderService.getBreadCrumbs();
                        }, function (newValue) {
                            $scope.breadCrumbs = newValue;
                        });
                    }

                    init();
                }
            };
        }]);
});

